import { render } from "./Fields.vue?vue&type=template&id=72e50e72&scoped=true"
import script from "./Fields.vue?vue&type=script&lang=js"
export * from "./Fields.vue?vue&type=script&lang=js"

import "./Fields.vue?vue&type=style&index=0&id=72e50e72&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-72e50e72"

export default script